var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path31",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd"
    },
    d: "m 212.43177,42.704303 a 17.282425,17.282425 0 0 0 -0.54688,0.03906 H 43.71302 a 17.282425,17.282425 0 0 0 -0.154297,-0.0039 17.282425,17.282425 0 0 0 -0.05469,0.0039 h -0.01953 v 0.002 a 17.282425,17.282425 0 0 0 -17.208984,17.277344 17.282425,17.282425 0 0 0 17.208984,17.27539 v 0.0059 H 212.3888 v -0.03906 a 17.282425,17.282425 0 0 0 0.043,0.0039 17.282425,17.282425 0 0 0 17.2832,-17.28125 17.282425,17.282425 0 0 0 -17.2832,-17.283203 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31-6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd"
    },
    d: "m 212.43178,110.70487 a 17.282425,17.282425 0 0 0 -0.54688,0.0391 H 43.713014 a 17.282425,17.282425 0 0 0 -0.154297,-0.004 17.282425,17.282425 0 0 0 -0.05469,0.004 h -0.01953 v 0.002 a 17.282425,17.282425 0 0 0 -17.208984,17.27735 17.282425,17.282425 0 0 0 17.208984,17.27539 v 0.006 H 212.38881 v -0.0391 a 17.282425,17.282425 0 0 0 0.043,0.004 17.282425,17.282425 0 0 0 17.2832,-17.28125 17.282425,17.282425 0 0 0 -17.2832,-17.28321 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31-6-7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd"
    },
    d: "m 212.43178,178.70165 a 17.282425,17.282425 0 0 0 -0.54688,0.0391 H 43.713011 a 17.282425,17.282425 0 0 0 -0.154297,-0.004 17.282425,17.282425 0 0 0 -0.05469,0.004 h -0.01953 v 0.002 A 17.282425,17.282425 0 0 0 26.27551,196.0201 17.282425,17.282425 0 0 0 43.484494,213.29549 v 0.006 H 212.38881 v -0.0391 a 17.282425,17.282425 0 0 0 0.043,0.004 17.282425,17.282425 0 0 0 17.2832,-17.28125 17.282425,17.282425 0 0 0 -17.2832,-17.28321 z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.e0a006a43e75b046484173d94aa6db32.svg";
export { ForwardRef as ReactComponent };